import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";

function t(t, n, r, e, i, a, o) {
  try {
    var u = t[a](o),
        c = u.value;
  } catch (t) {
    return void r(t);
  }

  u.done ? n(c) : Promise.resolve(c).then(e, i);
}

function n(n) {
  return function () {
    var r = this,
        e = arguments;
    return new Promise(function (i, a) {
      var o = n.apply(r, e);

      function u(n) {
        t(o, i, a, u, c, "next", n);
      }

      function c(n) {
        t(o, i, a, u, c, "throw", n);
      }

      u(void 0);
    });
  };
}

function r(t) {
  for (var n = new ArrayBuffer(t.length), r = new Uint8Array(n), e = 0, i = t.length; e < i; e++) {
    r[e] = t.charCodeAt(e);
  }

  return n;
}

function e(t) {
  return t.replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
}

function i(t) {
  return e(btoa(JSON.stringify(t)));
}

var a = function () {
  var t = n( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(t) {
    var n, a, o, u, c, p, f, l, s;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            n = t.privateKey, a = t.payload;

            if (!/BEGIN RSA PRIVATE KEY/.test(n)) {
              _context.next = 3;
              break;
            }

            throw new Error("[universal-github-app-jwt] Private Key is in PKCS#1 format, but only PKCS#8 is supported. See https://github.com/gr2m/universal-github-app-jwt#readme");

          case 3:
            u = {
              name: "RSASSA-PKCS1-v1_5",
              hash: {
                name: "SHA-256"
              }
            };
            c = (o = n.trim().split("\n").slice(1, -1).join(""), r(atob(o)));
            _context.next = 7;
            return crypto.subtle.importKey("pkcs8", c, u, !1, ["sign"]);

          case 7:
            p = _context.sent;

            f = function (t, n) {
              return "".concat(i(t), ".").concat(i(n));
            }({
              alg: "RS256",
              typ: "JWT"
            }, a);

            l = r(f);

            _context.t0 = function (t) {
              for (var n = "", r = new Uint8Array(t), i = r.byteLength, a = 0; a < i; a++) {
                n += String.fromCharCode(r[a]);
              }

              return e(btoa(n));
            };

            _context.next = 13;
            return crypto.subtle.sign(u.name, p, l);

          case 13:
            _context.t1 = _context.sent;
            s = (0, _context.t0)(_context.t1);
            return _context.abrupt("return", "".concat(f, ".").concat(s));

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function (n) {
    return t.apply(this, arguments);
  };
}();

function o(t) {
  return u.apply(this, arguments);
}

function u() {
  return (u = n( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(t) {
    var n, r, _t$now, e, i, o, u;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            n = t.id, r = t.privateKey, _t$now = t.now, e = _t$now === void 0 ? Math.floor(Date.now() / 1e3) : _t$now, i = e - 30, o = i + 600, u = {
              iat: i,
              exp: o,
              iss: n
            };
            _context2.t0 = n;
            _context2.t1 = o;
            _context2.next = 5;
            return a({
              privateKey: r,
              payload: u
            });

          case 5:
            _context2.t2 = _context2.sent;
            return _context2.abrupt("return", {
              appId: _context2.t0,
              expiration: _context2.t1,
              token: _context2.t2
            });

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }))).apply(this, arguments);
}

export { o as githubAppJwt };